import AIRecommended from "../../components/Ai_Comp/AIRecommended";
import AISyllabus from "../../components/Ai_Comp/AISyllabus";
import GetInTouch from "../../components/common/Contact/GetInTouch";
import CourseFAQ from "../../components/common/CourseFAQ/CourseFAQ";
import CourseHeroSection from "../../components/common/CourseHero/CourseHeroSection";
import CourseReasons from "../../components/common/CourseReasons/CourseReasons";
import PlaceMentRecord from "../../components/common/PlaceMent/PlaceMentRecord";
import ScrollText from "../../components/common/ScrollText/ScrollText";
import SEO from "../../components/common/seo/SEO";
import { aiFaqs } from "../../data/ai_section/aiFaqData";
import { aiReasons } from "../../data/ai_section/aiReasons";


const aiFeatures = [
    "Learn AI Online from experts working in top tech companies.",
    "Learn AI from scratch or only a portion that matters to you",
    "Career mentorship, resume support, and mock interviews etc.,",
    "Hands-on projects designed for real-world applications.",
    "Industry-recognized certifications",
];


function AIPage() {

    return (
        <>
 <SEO
                title="Artificial Intelligence Course Online | AI Training | FeesWorth"
                description="Learn Artificial Intelligence online through practical training, real-world projects, and industry-focused technologies. Build AI skills with expert guidance, hands-on learning, and career support."
                keywords="Artificial Intelligence Course, AI Course Online, AI Training, Artificial Intelligence Training, AI Certification Course, Learn Artificial Intelligence, AI Online Course, Artificial Intelligence Classes"
                canonical="https://feesworth.com/ai-courses-pay-after-learn"
            />
            <CourseHeroSection
                badge="ARTIFICIAL INTELLIGENCE TRAINING"
                title="AI Courses"
                titleHighlight="Online"
                logo="/AI_Logo.webp"
                logoAlt="Artificial Intelligence Logo"
                description="Learn Artificial Intelligence through practical training, real-world projects, and industry-focused technologies."
                features={aiFeatures}
            />


            <ScrollText />


            <CourseReasons
                courseName="Artificial Intelligence"
                reasons={aiReasons}
            />


            <PlaceMentRecord />


            <AISyllabus />

            <AIRecommended />


            <CourseFAQ
                courseName="Artificial Intelligence"
                faqs={aiFaqs}
            />


            <GetInTouch
                courseName="Artificial Intelligence"
            />

        </>
    );
}

export default AIPage;